/* @flow */
import * as React from 'react';
import cx from 'classnames';

import { SplitComposerModal } from 'chat/components/SplitComposer';
import Button from 'components/Button.jsx';
import CurrentUser from 'auth/CurrentUser';
import LayerTrigger from 'components/LayerTrigger.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import Text from 'components/Text.jsx';
import Timestamp from 'components/Timestamp.jsx';
import Tooltip from 'components/Tooltip.jsx';
import User from 'entities/User';

import type { OrganizationTarget, GroupTarget } from 'entities/Message';

type Props = {
  label?: any,
  className?: string,
  hideAnnouncements?: ?boolean,
  onComposeSelection?: ?Function,
  initialTarget?: ?(GroupTarget | OrganizationTarget),
};

export default class TriggerComposerButton extends React.Component<Props, void> {
  static defaultProps = {
    label: 'New message',
  };

  renderButton(options?: { disabled: boolean }) {
    const { label, className, ...props } = this.props;

    return (
      <Button
        disabled={options ? options.disabled : false}
        data-test-selector="universal_compose_button"
        {...props}
        className={cx('TriggerComposerButton', className)}
        eventKey="universal_composer.universal_compose.click"
        eventElementName="UniversalComposeButton">
        {label}
      </Button>
    );
  }

  renderEnabledButton() {
    return (
      <ModalTrigger
        modal={
          <SplitComposerModal
            initialTargets={this.props.initialTarget ? [this.props.initialTarget] : null}
          />
        }>
        {this.renderButton()}
      </ModalTrigger>
    );
  }

  renderDisabledButton(currentUser: User) {
    const timestamp = <Timestamp date={currentUser.getMutedUntil()} format="long" />;

    return (
      <LayerTrigger
        layer={
          <Tooltip>
            <Text align="center" element="div">
              Your messaging privileges have been temporarily suspended until {timestamp}.
            </Text>
          </Tooltip>
        }
        placement="bottom">
        {this.renderButton({ disabled: true })}
      </LayerTrigger>
    );
  }

  render() {
    const currentUser = CurrentUser.getUser();

    return currentUser.isMuted()
      ? this.renderDisabledButton(currentUser)
      : this.renderEnabledButton();
  }
}
